import { CultureInfo } from '../culture-info.model';
import { CultureInfoDe } from './de';

/**
 * @ignore
 */
export const CultureInfoDeIT: CultureInfo = {
  name: 'de-IT',
  displayName: 'Deutsch (Italien)',
  iso3LanguageCode: 'deu',
  iso2LanguageCode: 'de',
  ietfLanguageTag: 'de-IT',
  parent: CultureInfoDe
};
